<template>
  <!--
    Task list toolbar actions (right side of TasklistToolbar).

    Icons / controls:
    - Clear Filter — text underline link when table filters are active
    - mdi-content-save-outline  Save Layout — persists unsaved column order
    - mdi-clock-outline     Task Overdue Filter — toggles overdue-only view
    - lb-comment            Conversation — project-level comment thread
    - CustomizeColumnMenu   Column visibility and order
  -->
  <div class="tasklist-toolbar-actions d-flex align-center" data-testid="tasklist__toolbar-actions-group">
    <v-btn
      v-if="hasActiveTableFilter"
      text
      class="tasklist-toolbar-actions__clear-filter mr-1"
      @click="$emit('clear-filter')"
      data-testid="tasklist__toolbar-clear-filter-btn"
    >
      <span>Clear Filter</span>
    </v-btn>

    <v-tooltip v-if="columnOrderChanged" bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="tasklist-toolbar-actions__action-btn"
          :class="{ 'tasklist-toolbar-actions__action-btn--active': columnOrderChanged }"
          :disabled="!columnOrderChanged || loading"
          @click="$emit('save-column-order')"
          data-testid="tasklist__save-column-order-btn"
        >
          <v-icon small>mdi-content-save-outline</v-icon>
        </v-btn>
      </template>
      <span>Save Layout</span>
    </v-tooltip>

    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="tasklist-toolbar-actions__action-btn"
          :class="{ 'tasklist-toolbar-actions__action-btn--overdue-active': overDueDate }"
          @click="$emit('overdue-filter')"
          data-testid="tasklist__toolbar-overdue-btn"
        >
          <img src="/img/icons/fbc-icons/OverdueFilter.svg" alt="Task Overdue Filter" data-testid="tasklist__toolbar-overdue-icon-img" />
        </v-btn>
      </template>
      <span>Task Overdue Filter</span>
    </v-tooltip>

    <v-tooltip v-if="showConversation" bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="tasklist-toolbar-actions__comment"
        >
          <lb-comment
            heading="Conversation"
            width="600"
            :recurring="false"
            :recurringText="''"
            :closed="metadata.stage !== 0"
            @markread="$emit('mark-conversation-read')"
            :notify="!metadata.conversation_read"
            :getapi="'/v2/financialclose/project/getconversation/' + metadata._id"
            :sendapi="'/v2/financialclose/project/addconversation/' + metadata._id"
            :readapi="'/v2/financialclose/project/markreadconversation/' + metadata._id"
            data-testid="tasklist__conversation-component"
          />
        </span>
      </template>
      <span>Conversation</span>
    </v-tooltip>

    <CustomizeColumnMenu
      v-model="menuOpen"
      class="tasklist-toolbar-actions__customize"
      :headers="tableHeadersFilter"
      :page-name="page_name"
      :loading="loading"
      :show-header-info-icon="true"
      color="primary"
      data-testid-prefix="tasklist"
      @apply="$emit('apply-columns', $event)"
      @save="$emit('save-columns', $event)"
    />
  </div>
</template>

<script>
import './TasklistToolbarActions.scss';
import CustomizeColumnMenu from '../../../../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue';

/**
 * Icon action group on the right side of TasklistToolbar (filter, layout, overdue,
 * conversation, column customize).
 */
export default {
  name: 'TasklistToolbarActions',
  components: {
    CustomizeColumnMenu,
  },
  props: {
    hasActiveTableFilter: {
      type: Boolean,
      default: false,
    },
    columnOrderChanged: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default: () => ({}),
    },
    overDueDate: {
      type: Boolean,
      default: false,
    },
    tableHeadersFilter: {
      type: Array,
      default: () => [],
    },
    page_name: {
      type: String,
      default: 'tasklist',
    },
    showConversation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menuOpen: false,
    };
  },
};
</script>
